import LocationIcon from '@/components/icons/parking/Location';
import { useTickSoundInteraction } from '@/hooks';
import type { AreaInfoDetail, ParkingRecord } from '@/services/dto/parking';
import { useConfigStore } from '@/stores';
import { addCommaAfterNumber } from '@/utils/parking';
import { useTranslation } from 'react-i18next';

interface HeaderVerticalProps {
    result: ParkingRecord;
    isUseLocation?: boolean;
    areaInfo: AreaInfoDetail | null;
}

export default function HeaderVertical({ result, isUseLocation, areaInfo }: HeaderVerticalProps) {
    const { t } = useTranslation();
    const { playTick } = useTickSoundInteraction();
    const formattedLicenseplate = addCommaAfterNumber(result.licenseplate);
    const buildingName = useConfigStore((state) => state.config.server?.building?.name?.ko) ?? t('common.lotteWorldMall');

    return (
        <div className="widescreen:hidden fullscreen:w-full flex w-[calc(872*var(--vw-unit))] text-center">
            <div
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        playTick();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}
                data-region-nav
                data-region-order={2}
                tabIndex={2}
                data-interactive
                aria-label={`${t('parking.vehicleNumber')} ${formattedLicenseplate}`}
                className={`${isUseLocation ? 'fullscreen:max-w-[calc(360*var(--vw-unit))] max-w-[calc(360*var(--vw-unit))]' : ''} focus-border flex h-[calc(134*var(--vh-unit))] w-full flex-col items-center justify-center gap-[calc(10*var(--vh-unit))] self-stretch rounded-[calc(8*var(--vh-unit))] border-[calc(2*var(--vh-unit))] border-[var(--color-border-gray-ccc)] px-[calc(20*var(--vw-unit))] pt-[calc(12*var(--vh-unit))] pb-[calc(32*var(--vh-unit))]`}
            >
                <div className="text-center">
                    <div className="mb-[calc(10*var(--vh-unit))] text-[calc(20*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-medium text-[var(--color-text-color-99938f)]">
                        {t('parking.vehicleNumber')}
                    </div>
                    <div className="number text-[calc(40*var(--vh-unit))] leading-[calc(52*var(--vh-unit))] font-bold text-[var(--color-text-main01)]">
                        {result.licenseplate}
                    </div>
                </div>
            </div>
            {isUseLocation && (
                <div
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            playTick();
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                    data-region-nav
                    data-region-order={2}
                    tabIndex={2}
                    data-interactive
                    aria-label={`${areaInfo?.parkArea}-${buildingName}-${areaInfo?.parkStair}`}
                    className="focus-border flex h-[calc(134*var(--vh-unit))] w-full flex-col items-center justify-center gap-[calc(10*var(--vh-unit))] self-stretch"
                >
                    <div className="flex items-center gap-[calc(8*var(--vw-unit))] text-[var(--color-text-color-99938f)]">
                        <LocationIcon style={{ width: 'calc(37*var(--vw-unit))', height: 'calc(36*var(--vh-unit))' }} />
                        <span className="text-center text-[calc(26*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-semibold tracking-[calc(-0.572*var(--vh-unit))] text-[var(--color-text-sub01)]">
                            {areaInfo?.parkArea}-{buildingName}-{areaInfo?.parkStair}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}
